<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="fornecedorGestaoGrupos.content"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="fornecedorGestaoGrupos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum grupo encontrado"
      loading-text="Carregando grupos..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        {{ item.id }}
      </template>
      <template v-slot:item.descricao="{ item }">
        {{ item.descricao }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo small :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }">
        <div class="text-right">
          <v-btn icon @click="goToFornecedorGestaoGrupos(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon
                 @click="onClickDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>

export default {
  props: {
    fornecedorGestaoGrupos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'Código',
          value: 'id',
          width: '10%',
        },
        {
          text: 'Descrição',
          value: 'descricao',
          width: '70%',
        },
        {
          text: 'Situação',
          value: 'ativo',
          width: '10%',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
          width: '10%',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este grupo?',
        'Esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    goToFornecedorGestaoGrupos(item) {
      this.$router.push({
        name: 'main.fornecedores-gestao-grupos.edicao',
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>
